// What the photo steps found, drawn on a frame's photo for the viewer (Viewer.setImage takes the result): the
// photo's line segments red, its corners green, the depth's jumps cyan
// and creases blue, and when matched, matched corners yellow and the photo lines a depth edge agrees with white.
import type { FrameFeats } from './feats.ts';

export interface Marks { matched?: Uint8Array | null; agreed?: Uint8Array | null }

/** img with ff's features drawn on (a new bitmap; img is left as it is). */
export async function overlay(img: ImageBitmap, ff: FrameFeats, m: Marks = {}): Promise<ImageBitmap> {
  const cv = new OffscreenCanvas(img.width, img.height), g = cv.getContext('2d')!;
  g.drawImage(img, 0, 0);
  const lw = Math.max(1, img.width / 400);
  const segs = (s: Float32Array, n: number, col: (i: number) => string, w: number) => {
    g.lineWidth = w;
    for (let i = 0; i < n; i++) { g.strokeStyle = col(i); g.beginPath(); g.moveTo(s[4 * i], s[4 * i + 1]); g.lineTo(s[4 * i + 2], s[4 * i + 3]); g.stroke(); }
  };
  segs(ff.depth.jump.seg, ff.depth.jump.n, () => 'rgba(0, 230, 255, 0.8)', lw);
  segs(ff.depth.crease.seg, ff.depth.crease.n, () => 'rgba(60, 110, 255, 0.8)', lw);
  if (ff.segs) segs(ff.segs.seg, ff.segs.n, i => (m.agreed?.[i] ? '#ffffff' : '#ff3b30'), 1.5 * lw);
  if (ff.corners) {
    g.lineWidth = lw;
    for (let i = 0; i < ff.corners.n; i++) {
      g.strokeStyle = m.matched?.[i] ? '#ffd60a' : '#30d158';
      g.beginPath(); g.arc(ff.corners.xy[2 * i], ff.corners.xy[2 * i + 1], 3 * lw, 0, 2 * Math.PI); g.stroke();
    }
  }
  return createImageBitmap(cv);
}
